import { Box, Text, Link, Button, Tag, Stack } from "@chakra-ui/react"
import { isBefore } from "date-fns"
import { useGlobalState } from "providers/globalState"
import FormattedDateString from "components/agenda/formattedDateString"
import FormattedTimeString from "components/agenda/formattedTimeString"
import Presentation from "./presentation"
import { useVenueLabel } from "./programGuide/SessionDetail"
import externalCME from "config/externalCME"
import { roomsHidden } from "lib/rooms"

export default function Session(props) {
    const { site } = useGlobalState()
    const venueLabel = useVenueLabel(props.venue)

    const channel = site.channels?.find(c => c.slug === props.channelSlug)

    const showAddEvent =
        (props.addevent_id || props.addevent_dynamic) && isBefore(new Date(), new Date(props.datetime_end))

    const isNotVirtualAndNotOndemand =
        site?.meeting.type !== "Virtual" && props.type !== "ondemand" && !props.params.on_demand
    const hideRoom = props.forStreaming
    const hideAccreditation = props.forStreaming
    const showPrintButton = !props.forStreaming
    const accreditationText = externalCME[site?.meeting?.siteId]?.includes(props.root_id)
        ? "This content is CME accredited."
        : props.params.accreditation_text

    const buttonStyles = {
        color: "#eee",
        bg: props.color || "#748FA2",
        borderRadius: 0,
        px: 9,
        py: 1,
        mt: 4,
        fontSize: "14px",
        _hover: { bg: props.color },
    }

    function printSession() {
        let url = "/program-guide/print/session/" + props.id
        url += props.type === "ondemand" ? "?type=ondemand" : ""
        const newWindow = window.open(url)
    }

    const isExhibitHall = props.session_type === "Exhibit Hall"

    return (
        <Box className="program__session" p={props.noPadding ? 0 : 4} bg={props.bgColor ? props.bgColor : "#eee"}>
            <ConditionalMargin m="5px 0 25px">
                {isNotVirtualAndNotOndemand && (
                    <>
                        <Text className="program__sessionDate" m={0} color="#333">
                            <FormattedDateString date={props.datetime_start} format="EEEE, MMMM d" />,{" "}
                            <FormattedTimeString
                                event={props}
                                config={{
                                    showEndTime: true,
                                    showTimezone: true,
                                }}
                            />
                        </Text>
                        {!hideRoom && !roomsHidden(site) && (
                            <Text className="program__sessionRoom" m={0} color="#333">
                                Room: {venueLabel || "TBD"}
                            </Text>
                        )}
                    </>
                )}
                {channel?.channelStatus && channel.channelStatus !== "default" && (
                    <Text m={0} color="#777" fontWeight={600}>
                        {channel.channelStatus}
                    </Text>
                )}
                {!hideAccreditation && (
                    <Text className="program__cmeText" m={0} color="#333">
                        {accreditationText}
                    </Text>
                )}
                {isExhibitHall && props.description && (
                    <Text
                        className="program__sessionDescription"
                        fontSize={15}
                        lineHeight={1.2}
                        mt={1}
                        mb={3}
                        color={props.level ? "#333" : props.color}
                    >
                        {props.description}
                    </Text>
                )}
                {props.tracks.length || props.event_topics.length ? (
                    <Stack mt={2} mb={3} gap={1} direction="row" flexWrap="wrap">
                        {!site.meeting.hideTracks && site.meeting.groupEventAtSecondLevel && props.tracks && (
                            <>
                                {props.tracks.map((track, i) => (
                                    <Tag.Root size="sm" key={i} variant="solid" bgColor="#518cfc">
                                        <Tag.Label>{track}</Tag.Label>
                                    </Tag.Root>
                                ))}
                            </>
                        )}
                        {props.event_topics && (
                            <>
                                {props.event_topics.map((topic, i) => (
                                    <Tag.Root size="sm" key={i} variant="solid" bgColor="#748FA2">
                                        <Tag.Label>{topic}</Tag.Label>
                                    </Tag.Root>
                                ))}
                            </>
                        )}
                    </Stack>
                ) : null}
                {showAddEvent && (
                    <Link
                        className="program__addEvent"
                        href={props.addevent_dynamic || `https://www.addevent.com/event/${props.addevent_id}`}
                        _hover={{ textDecoration: "none" }}
                        target="_blank"
                    >
                        <Button className="no-print" {...buttonStyles}>
                            ADD TO CALENDAR
                        </Button>
                    </Link>
                )}
            </ConditionalMargin>
            {props.children.map((event, i) => {
                if (site.search?.terms?.length && !event.searchValue && !props.searchValue) {
                    return null
                }
                return (
                    <Presentation
                        key={i}
                        level={0}
                        type={props.type}
                        suppressLinks={props.suppressLinks}
                        color={props.color}
                        channelSlug={props.channelSlug}
                        {...event}
                    />
                )
            })}
            {showPrintButton && (
                <Button onClick={printSession} className="program__printBtn no-print" {...buttonStyles}>
                    PRINT
                </Button>
            )}
        </Box>
    )
}

function ConditionalMargin({ m, children }) {
    if (!children?.some(child => child)) return null

    return (
        <Box m={m} className="program__sessionDetails">
            {children}
        </Box>
    )
}
